/**
 * The render function a `QueryBoundary` wants, for a surface that shows a read
 * failure and a way to ask again.
 *
 * Its own file because the arrow it returns renders, which makes it a second
 * component as far as `react/no-multi-comp` is concerned — and the rule is
 * right that the two are separate things.
 */import*as React from"react";import ReadFailure from"web/shared/relay/ReadFailure";// Six surfaces wrote the same one-line arrow, which is one place for it now:
// the boundary hands a message, and the surface has already decided how its
// failures look and what asking again means, so neither belongs in the arrow.
import{jsx as _jsx}from"react/jsx-runtime";export function readFailureRenderer(textStyle,onAskAgain){return message=>/*#__PURE__*/_jsx(ReadFailure,{message:message,textStyle:textStyle,onAskAgain:onAskAgain});}